import * as React from "react";
import { Input, Col, Form, Checkbox } from "antd";

import { FormInstance } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import { IIndexType } from "../../model/IndexType";
import { IIndexTypeAttribute } from "../../model/IndexTypeAttribute";

const FormFields = {
  ID: "id",
  CODE: "code",
  DESCRIPTION: "description",
  ATTRIBUTES: "attributes",
  NAME: "name",
  VALID: "valid"
};

const IndexTypeForm = ({
  translate,
  form,
  rowData,
  indexTypeAttributes,
  createIndexTypeAttribute,
  deleteIndexTypeAttribute
}: {
  translate: any;
  form: FormInstance;
  rowData?: IIndexType;
  indexTypeAttributes?: IIndexTypeAttribute[];
  createIndexTypeAttribute?: any;
  deleteIndexTypeAttribute?: any;
}) => {
  function renderIndexTypeAttributes(required: boolean) {
    return indexTypeAttributes?.map((item) => {
      return (
        item.required === required && (
          <div
            style={{
              border: "5px #f0f0f0 solid",
              background: "#f0f0f0",
              width: "fit-content",
              paddingLeft: "5px",
              marginTop: "5px",
              borderRadius: "20px",
              display: "flex",
              marginRight: "0.5em"
            }}
          >
            {item?.attribute}
            <div
              style={{
                marginLeft: "1.2em",
                marginRight: "0.5em",
                cursor: "pointer"
              }}
              onClick={(e) => {
                deleteIndexTypeAttribute(item);
              }}
            >
              x
            </div>
          </div>
        )
      );
    });
  }

  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Col xs={24} sm={24}>
        <Form.Item
          label={translate("editors.case_law_document_types.code")}
          name={FormFields.CODE}
          initialValue={rowData?.code}
          rules={[
            {
              required: true,
              message: translate(
                "editors.case_law_document_types.required_messages",
                {
                  field: translate("editors.case_law_document_types.code")
                }
              )
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24}>
        <Form.Item
          label={translate("editors.case_law_document_types.name")}
          name={FormFields.NAME}
          initialValue={rowData?.name}
          rules={[
            {
              required: true,
              message: translate(
                "editors.case_law_document_types.required_messages",
                {
                  field: translate("editors.case_law_document_types.name")
                }
              )
            }
          ]}
        >
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} sm={24}>
        <Form.Item
          label={translate("editors.case_law_document_types.description")}
          name={FormFields.DESCRIPTION}
          initialValue={rowData?.description}
        >
          <TextArea />
        </Form.Item>
      </Col>
      <Col>
        <Form.Item
          label={translate(
            "editors.case_law_document_types.required_attributes"
          )}
        >
          <Input
            onPressEnter={(e) => {
              createIndexTypeAttribute(rowData, e.currentTarget.value, true);
            }}
            placeholder={translate(
              "editors.organisations.case_law_document_types.placeholder"
            )}
            allowClear={true}
          />
          <div style={{ display: "flex" }}>
            {renderIndexTypeAttributes(true)}
          </div>
        </Form.Item>
      </Col>
      <Col>
        <Form.Item
          label={translate(
            "editors.case_law_document_types.optional_attributes"
          )}
        >
          <Input
            onPressEnter={(e) => {
              createIndexTypeAttribute(rowData, e.currentTarget.value, false);
            }}
            placeholder={translate(
              "editors.organisations.case_law_document_types.placeholder"
            )}
            allowClear={true}
          />
          <div style={{ display: "flex" }}>
            {renderIndexTypeAttributes(false)}
          </div>
        </Form.Item>
      </Col>
      <Col>
        <Form.Item
          label={translate("editors.case_law_document_types.valid")}
          className={"png-form-item-horizontal-checkbox mb-0"}
          name={FormFields.VALID}
          valuePropName={"checked"}
          initialValue={rowData?.valid ?? true}
        >
          <Checkbox />
        </Form.Item>
      </Col>
    </Form>
  );
};

export default IndexTypeForm;
